import { BACKEND_BASE_URL } from './api';

// Session storage keys
export const AUTH_ATTEMPTED_KEY = 'auth_attempted';
export const REFRESH_CALLED_KEY = 'refresh_called';
export const JWT_CACHE_KEY = 'cached_jwt';

// Environment-specific configuration
const isDevelopment = process.env.NODE_ENV === 'development';

// Selects the auth.providers.<env> block on the backend; mirrors
// APP_CONFIG_auth_environment in .gke/scripts/set-config.sh.
const AUTH_ENV_BY_HOSTNAME: Record<string, string> = {
  'simplify.developers.telus.digital': 'development',
  'simplify.staging.developers.telus.digital': 'staging',
  'simplify.telus.com': 'production',
};

export const AUTH_ENV = isDevelopment
  ? 'development'
  : AUTH_ENV_BY_HOSTNAME[window.location.hostname] ?? 'production';

// API endpoints
export const REFRESH_URL = `${BACKEND_BASE_URL}/api/auth/google/refresh?env=${AUTH_ENV}`;

// Auth URL configuration
export const AUTH_BASE_URL = `${BACKEND_BASE_URL}/api/auth/google/start`;

export const AUTH_SCOPE = 'openid profile email';

export const AUTH_ORIGIN = isDevelopment
  ? 'http://localhost:3000'
  : window.location.origin;

export const AUTH_FLOW = 'redirect';

// Error messages
export const ERROR_AUTH_SERVICE = 'Authentication service error';
export const ERROR_CONNECTION = 'Unable to connect to authentication service.';
export const ERROR_AUTH_FAILED = 'Authentication failed. Please contact support or try refreshing the page.';

// Auth error types
export const AUTH_ERROR_INVALID_GRANT = 'invalid_grant';
export const AUTH_ERROR_REFRESH_TOKEN = 'refresh token';

// HTTP status codes
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * Builds the authentication URL with the current path
 */
export function buildAuthUrl(currentPath: string): string {
  const params = new URLSearchParams({
    scope: AUTH_SCOPE,
    origin: AUTH_ORIGIN,
    redirectUrl: `${AUTH_ORIGIN}${currentPath}`,
    flow: AUTH_FLOW,
    env: AUTH_ENV,
  });
  return `${AUTH_BASE_URL}?${params.toString()}`;
}
